import { gql, useQuery } from "@apollo/client";
import Errors from "components/base/Errors";
import { Select } from "components/base/Form";
import SearchBar from "components/base/SearchBar";
import Spinner from "components/base/Spinner";
import { useState } from "react";
import { searchByProp } from "utils/search";

const FETCH_ODOO_VENDORS = gql`
  query FETCH_ODOO_VENDORS($company: String!) {
    odooVendors(company: $company)
  }
`;

const OdooVendorsView = ({ onSelect }) => {
  const [company, setCompany] = useState("AB");
  const { loading, error, data } = useQuery(FETCH_ODOO_VENDORS, {
    variables: { company },
    fetchPolicy: "network-only",
  });
  const [searchText, setSearchText] = useState("");

  if (data) console.log(JSON.parse(data.odooVendors));

  return (
    <div>
      <div className="flex space-x-3 items-center">
        <Select value={company} onChange={(e) => setCompany(e.target.value)}>
          <option value="AB">AB</option>
          <option value="LTD">LTD</option>
        </Select>
        <div className="flex-1">
          <SearchBar
            value={searchText}
            onChange={setSearchText}
            placeholder="Search by name"
          />
        </div>
      </div>

      <div className="mt-2 divide-y dark:divide-gray-700 relativs">
        {loading && (
          <div className="p-20 relative">
            <Spinner />
          </div>
        )}
        {error && <Errors error={error} />}

        {data &&
          JSON.parse(data.odooVendors)
            .filter((i) => searchByProp(i, ["name"], searchText))
            .map((i) => (
              <div
                key={i.id}
                className="py-2 cursor-pointer hover:bg-blue-100 dark:hover:bg-blue-900"
                onClick={() => onSelect(company, i)}
              >
                <div>{i.name}</div>
              </div>
            ))}
      </div>
    </div>
  );
};

export default OdooVendorsView;
